import { render, staticRenderFns } from "./BlogbookAssistant.vue?vue&type=template&id=c20fdd38&scoped=true&"
import script from "./BlogbookAssistant.vue?vue&type=script&lang=js&"
export * from "./BlogbookAssistant.vue?vue&type=script&lang=js&"
import style0 from "./BlogbookAssistant.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BlogbookAssistant.vue?vue&type=style&index=1&id=c20fdd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20fdd38",
  null
  
)

export default component.exports